// Mock integrations for local development

export const Core = {
  InvokeLLM: async (params) => {
    console.log('Mock InvokeLLM:', params);
    return { success: true, response: 'Mock LLM response' };
  },
  SendEmail: async (params) => {
    console.log('Mock SendEmail:', params);
    return { success: true, message: 'Email sent (mock)' };
  },
  UploadFile: async (file) => {
    console.log('Mock UploadFile:', file?.name);
    return {
      success: true,
      url: `https://example.com/uploads/${file?.name || 'file'}`,
      filename: file?.name || 'file'
    };
  },
  GenerateImage: async (params) => {
    console.log('Mock GenerateImage:', params);
    return {
      success: true,
      url: 'https://via.placeholder.com/400x300',
      message: 'Image generated (mock)'
    };
  },
  ExtractDataFromUploadedFile: async (params) => {
    console.log('Mock ExtractDataFromUploadedFile:', params);
    return {
      success: true,
      data: { extracted: 'mock data' }
    };
  },
  CreateFileSignedUrl: async (params) => {
    console.log('Mock CreateFileSignedUrl:', params);
    return {
      success: true,
      url: 'https://example.com/signed-url'
    };
  },
  UploadPrivateFile: async (file) => {
    console.log('Mock UploadPrivateFile:', file?.name);
    return {
      success: true,
      url: `https://example.com/private/${file?.name || 'file'}`,
      filename: file?.name || 'file'
    };
  }
};

export const InvokeLLM = Core.InvokeLLM;
export const SendEmail = Core.SendEmail;
export const UploadFile = Core.UploadFile;
export const GenerateImage = Core.GenerateImage;
export const ExtractDataFromUploadedFile = Core.ExtractDataFromUploadedFile;
export const CreateFileSignedUrl = Core.CreateFileSignedUrl;
export const UploadPrivateFile = Core.UploadPrivateFile;
